import React from 'react'

// import { Link } from 'tools/Link'
import { cleanPath } from 'utils/string'
import { ellipsisTruncate } from 'utils/string'

import { SECTION as orgSection } from 'hub/Org'
import paths from 'hub/paths'

import { corpSiteLink } from './SitemapNav'

function CorpLink({ to, children, className = '' }) {
  // this is only for our corp site, we want the normal experience
  return (
    <a href={to} className={className}>
      {children}
    </a>
  )
}

export const admin = [
  {
    id: 'admin-div',
    divider: true,
    authz: 'location_manage'
  },
  {
    id: 'admin-header',
    miniLabel: 'Admin',
    authz: 'location_manage'
  },
  {
    to: paths.sys.registrations,
    label: 'Registrations',
    desc: 'Register servers',
    icon: 'truck',
    authz: 'location_manage'
  },
  {
    to: paths.sys.inventory,
    label: 'Inventory',
    desc: 'Manage system inventory',
    icon: 'file',
    authz: 'inventory_manage'
  },
  {
    to: paths.sys.sku,
    label: 'SKU',
    icon: 'clipboard-list',
    desc: 'Manage SKUs',
    authz: 'location_manage'
  },
  {
    to: paths.sys.taxonomy,
    label: 'Taxonomy',
    icon: 'table',
    desc: 'Manage System Taxonomy',
    authz: 'location_manage'
  },
  {
    label: 'Reports',
    to: paths.sys.reports,
    icon: 'chart-line',
    desc: 'Cato Administrative Reports',
    authz: 'system_admin'
  },
  {
    to: paths.sys.admin,
    label: 'Site Admin',
    icon: 'cog',
    desc: 'System Admin',
    authz: 'system_admin'
  }
]

const manage = (org = {}) =>
  [
    // {
    //   label: 'Hub Home',
    //   showHome: false,
    //   Linker: Link,
    //   to: '/'
    // },
    //////////////////////////////////////////////////////////////////////////////
    {
      label: orgSection,
      icon: 'building',
      displayOrgName: true,
      desc: "Configure your Organization's Account",
      to: paths.public.org
    },
    {
      label: <span className="b">{ellipsisTruncate(org?.name ?? '', 16)}</span>,
      icon: 'star',
      displayOrgName: true,
      hide: org.name == null,
      showHome: false,
      desc: "Configure your Organization's Account",
      to: cleanPath(paths.public.org, org.id ?? '_', 'settings')
    },
    {
      id: 'org-div',
      hide: org.name == null,
      divider: true
    },
    {
      miniLabel: 'Organization',
      hide: org.name == null,
      id: 'org-header'
    },
    // {
    //   label: 'Request Server',
    //   icon: 'server',
    //   desc: (
    //     <>
    //       Request a Server
    //       <br />
    //       (watch here for more functionality in the future)
    //     </>
    //   ),
    //   to: '/start/'
    // },
    {
      label: 'Compute',
      icon: 'server',
      desc: 'Manage servers, ports, and volumes',
      displayOrgName: true,
      hide: org.name == null,
      to: cleanPath(paths.public.compute, org.id ?? '_', 'server')
    },
    ...admin
    //{
    //label: 'Network',
    //desc: 'Manage VLANs and IPs',
    //icon: 'network-wired',
    //displayOrgName: true,
    //to: paths.public.network
    //},
    //{
    //label: 'Storage',
    //desc: 'Manage network storage',
    //icon: 'database',
    //displayOrgName: true,
    //to: paths.public.storage
    //},
    //////////////////////////////////////////////////////////////////////////////
  ].filter((item) => !item.hide)

export const manageSections = (org, section) =>
  manage(org).find(({ label }) => label === section)

const hamburger = [
  {
    to: paths.public.user,
    label: 'Preferences'
  },
  {
    label: 'Knowledgebase',
    icon: 'book',
    desc: 'Learn about using the Cato Console and API',
    to: 'https://cato.digital/kb/',
    Linker: CorpLink
  },
  {
    label: 'Cato Hub',
    showHome: false,
    to: '/'
  },
  {
    label: 'Cato Website',
    showHome: false,
    to: corpSiteLink('/'),
    Linker: CorpLink
  },
  {
    to: 'https://cato.digital/support/',
    label: 'Support',
    icon: 'file',
    Linker: CorpLink
  },
  ...admin,
  {
    divider: true,
    id: 'signout-div'
  },
  {
    to: paths.public.signout,
    label: 'Sign Out'
  }
]

export default { manage, admin, manageSections, hamburger }
